(function () {
    'use strict';
    var m = angular.module('app');
    m.directive('curtainWrapper', ["path", "feature", "autologinHelper", function (path, feature, autologinHelper) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('main').directive('curtain-wrapper').template(),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.feature = feature;
                window.addEventListener('message', function (event) {
                    if (event.data.closeCurtain) {
                        document.getElementById('inner-vertical-puller').click();
                        var curtainFrame = document.getElementById('curtain-frame');
                        curtainFrame.contentWindow.postMessage({
                            closedCurtain: true,
                            service: event.data.service,
                            navigateUrl: event.data.navigateUrl
                        }, '*');
                    }
                });
                function getParameterByName(name, url) {
                    if (!url)
                        url = window.location.href;
                    name = name.replace(/[\[\]]/g, '\\$&');
                    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
                    if (!results)
                        return null;
                    if (!results[2])
                        return '';
                    return decodeURIComponent(results[2].replace(/\+/g, ' '));
                }
                $scope.toggleCurtain = function (close) {
                    var curtainOverlay = document.getElementById('curtain-overlay');
                    var curtain = document.getElementById('curtain');
                    var verticalPuller = document.getElementById('inner-vertical-puller');
                    var outerVerticalPuller = document.getElementById('outer-vertical-puller');
                    //Replace pg-background with your page container identifier
                    //(Used to change background color to black when curtain is in open state)
                    var pgBackground = document.getElementsByClassName('guiV2 sonicwall-theme')[0];
                    var curtainFrame = document.getElementById('curtain-frame');
                    if (close) {
                        curtain.style.top = '-100%';
                        setTimeout(function () {
                            curtainOverlay.style.display = 'none';
                            outerVerticalPuller.style.top = outerVerticalPuller.offsetTop + 16 + 'px';
                            outerVerticalPuller.style.transform = 'rotate(180deg)';
                            outerVerticalPuller.style.webkitTransform = 'rotate(180deg)';
                            verticalPuller.style.transform = 'rotate(180deg)';
                            verticalPuller.style.webkitTransform = 'rotate(180deg)';
                        }, 1000);
                    } else {
                        //Available as url query param 'spogSrc'
                        // var paramSpogSrc = getParameterByName('spogSrc');
                        var paramSpogSrc = autologinHelper.spogSrc();
                        var srcUrl;
                        if (!paramSpogSrc) {
                            srcUrl = 'https://software.sonicwall.com/Applications/CSCCurtain/demo.html';
                        } else {
                            srcUrl = paramSpogSrc;
                        }
                        curtainFrame.src = srcUrl;
                        verticalPuller.style.top = verticalPuller.offsetTop + 16 + 'px';
                        curtain.style.top = '0';
                        setTimeout(function () {
                            curtainOverlay.style.display = 'block';
                            verticalPuller.style.top = verticalPuller.offsetTop - 16 + 'px';
                            outerVerticalPuller.style.top = outerVerticalPuller.offsetTop - 16 + 'px';
                            verticalPuller.style.transform = 'rotate(0deg)';
                            outerVerticalPuller.style.transform = 'rotate(0deg)';
                            verticalPuller.style.webkitTransform = 'rotate(0deg)';
                            outerVerticalPuller.style.webkitTransform = 'rotate(0deg)';
                        }, 1000);
                        curtainFrame.onerror = function (e) {
                            console.log('Error on curtain' + e);
                        };
                    }
                };
            }
        };
    }]);
}());